import * as React from 'react';
import { Link } from 'react-router';
import classNames from '../../../helpers/classNames';
interface ICardFooterItemProps {
	onItemClick?: () => void;
	to?: string;
	className?: string;
}

export default class CardFooterItem extends React.Component<
	ICardFooterItemProps,
	{}
> {
	public render() {
		const { to, onItemClick, children, className } = this.props;

		const classes = classNames('card-footer-item', className ? className : '');

		if (to) {
			return (
				<Link className={classes} to={to}>
					{children}
				</Link>
			);
		}

		if (onItemClick) {
			return (
				<a className={classes} onClick={onItemClick}>
					{children}
				</a>
			);
		}

		return <div className={classes}>{children}</div>;
	}
}
